module.exports = __webpack_public_path__ + "img/11.caa41494.png";